import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {Card, Grid, Input, Button, Tab, Icon} from 'semantic-ui-react';
import {dateFormatPicker, noTimeZoneShortISODate} from '../../../common/constants/datesFormat';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import Summary from './summary';
import Detail from './detail';
import './prioritizationIndices.scss';

const OFFSET = 0;

const PANES_INDICES = {
  'SUMMARY': 0,
  'DETAIL': 1,
};

const panes = [
  {'menuItem': 'Resumen'},
  {'menuItem': 'Detalle'},
];

class PrioritizationIndices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'activeTabIndex': 0,
      'startDateFilter': moment().format(noTimeZoneShortISODate),
      'endDateFilter': moment().format(noTimeZoneShortISODate),
    };
    this.onTabChange = this.onTabChange.bind(this);
    this.handleSearchClick = this.handleSearchClick.bind(this);
    this.handleDownloadClick = this.handleDownloadClick.bind(this);
    this.changeStartDate = this.changeStartDate.bind(this);
    this.changeEndDate = this.changeEndDate.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.PrioritizationIndicesReport, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.clearPrioritizationIndices();
  }

  handleSearchClick(value) {
    const {pageSize} = this.props;
    const {startDateFilter, endDateFilter, activeTabIndex} = this.state;
    const params = {'startDate': startDateFilter, 'endDate': endDateFilter, 'executeSP': 'yes'};

    this.props.changePrioritizationIndicesListPage(OFFSET);
    if (activeTabIndex === PANES_INDICES.SUMMARY) {
      this.props.fetchPrioritizationIndicesSummary(params, pageSize, value);
      return;
    }
    this.props.fetchPrioritizationIndicesDetail(params, pageSize, value);
  }

  handleDownloadClick() {
    const {startDateFilter, endDateFilter, activeTabIndex} = this.state;
    const params = {'startDate': startDateFilter, 'endDate': endDateFilter};

    this.props.changePrioritizationIndicesListPage(OFFSET);
    if (activeTabIndex === PANES_INDICES.SUMMARY) {
      this.props.downloadPrioritizationIndicesSummaryReport(params);
      return;
    }
    this.props.downloadPrioritizationIndicesDetailReport(params);
  }

  onTabChange(event, data) {
    const {loading, downloading} = this.props;
    const {activeTabIndex} = this.state;
    if (loading || downloading || activeTabIndex === data.activeIndex) {
      return;
    }
    this.setState({'activeTabIndex': data.activeIndex}, () => this.props.clearPrioritizationIndices());
  }

  changeStartDate(date) {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);

    const {startDateFilter, endDateFilter} = this.state;
    if (dateFormatted === startDateFilter) {
      return;
    }

    this.props.clearPrioritizationIndices();

    const newState = {'startDateFilter': dateFormatted};
    if (!endDateFilter || (endDateFilter && moment(date) > moment(endDateFilter))) {
      newState.endDateFilter = dateFormatted;
    }
    this.setState(newState);
  }

  changeEndDate(date) {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);

    if (dateFormatted === this.state.endDateFilter) {
      return;
    }

    this.props.clearPrioritizationIndices();
    this.setState({'endDateFilter': dateFormatted});
  }

  renderFilterDates() {
    const {loading, downloading} = this.props;
    const {startDateFilter, endDateFilter} = this.state;

    return (
      <Grid textAlign='left'>
        <Grid.Row>
          <Grid.Column width={1} className='label'>
            <h4>Fecha Inicio</h4>
          </Grid.Column>
          <Grid.Column width={2}>
            <DatePicker
              customInput={
                <Input icon='calendar' size='small' />
              }
              dateFormat={dateFormatPicker}
              selected={startDateFilter ? moment(startDateFilter, noTimeZoneShortISODate).toDate() : null}
              onChange={this.changeStartDate}
              locale='es'
              placeholderText='Fecha Inicio'
              disabled={loading || downloading}
            />
          </Grid.Column>
          <Grid.Column width={1} className='label'>
            <h4>Fecha Fin</h4>
          </Grid.Column>
          <Grid.Column width={2}>
            <DatePicker
              customInput={
                <Input icon='calendar' size='small' />
              }
              dateFormat={dateFormatPicker}
              selected={endDateFilter ? moment(endDateFilter, noTimeZoneShortISODate).toDate() : null}
              onChange={this.changeEndDate}
              minDate={moment(startDateFilter).toDate()}
              placeholderText='Fecha Fin'
              disabled={loading || downloading}
              locale='es'
            />
          </Grid.Column>
          <Grid.Column width={3} />
          <Grid.Column width={2}>
            <Tab
              menu={{'secondary': true, 'pointing': true, 'color': 'red'}}
              panes={panes}
              activeIndex={this.state.activeTabIndex}
              onTabChange={this.onTabChange}
            />
          </Grid.Column>
          <Grid.Column width={5} textAlign='right'>
            <Button primary disabled={loading || downloading}
              onClick={this.handleSearchClick.bind(this, OFFSET)}>Buscar</Button>
            <Button primary disabled={loading || downloading} className='download' onClick={this.handleDownloadClick}>
              <Icon name='download' />
              Excel
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

  renderPanesContent() {
    const {startDateFilter, endDateFilter, activeTabIndex} = this.state;
    const params = {'startDate': startDateFilter, 'endDate': endDateFilter, 'executeSP': 'no'};

    switch (activeTabIndex) {
      default:
      case PANES_INDICES.SUMMARY:
        return <Summary parameters={params} />;
      case PANES_INDICES.DETAIL:
        return <Detail parameters={params} />;
    }
  }

  render() {
    return (
      <div className='prioritization-indices-report'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Índices de Priorización</h2>
            </div>
            <div className='filters-section'>
              {this.renderFilterDates()}
            </div>
          </div>
        </Card>
        {this.renderPanesContent()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.prioritizationIndices.loading,
    'downloading': state.prioritizationIndices.downloading,
    'pageSize': state.prioritizationIndices.pageSize,
    'permissions': state.session.permissions,
  };
};

const {
  navigateTo,
  clearPrioritizationIndices,
  fetchPrioritizationIndicesSummary,
  downloadPrioritizationIndicesSummaryReport,
  fetchPrioritizationIndicesDetail,
  downloadPrioritizationIndicesDetailReport,
  changePrioritizationIndicesListPage,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  clearPrioritizationIndices,
  fetchPrioritizationIndicesSummary,
  downloadPrioritizationIndicesSummaryReport,
  fetchPrioritizationIndicesDetail,
  downloadPrioritizationIndicesDetailReport,
  changePrioritizationIndicesListPage,
})(PrioritizationIndices);
